/** Copy for the /demo lead form, per intent (`?intent=`). */
export type DemoIntent = 'demo' | 'enterprise-contact' | 'sales';

interface IntentCopy {
  readonly h: string;
  readonly p: string;
  readonly btn: string;
  readonly note: string;
  /** Scheduling is optional: the visitor may wait for the team to reach out instead. */
  readonly optional: boolean;
}

const ENTERPRISE_CONTACT_COPY: IntentCopy = {
  h: 'Talk with our enterprise team.',
  p: "Tell us a little about your organization and what you're looking to solve. A member of the ReTax360 team can follow up with you, or you can select an available time immediately after submitting your information.",
  btn: 'Send my information',
  note: 'Next, you can choose a time or wait for our team to reach out.',
  optional: true,
};

export const INTENTS: Readonly<Record<DemoIntent, IntentCopy>> = {
  demo: {
    h: 'See how ReTax360 could work inside your organization.',
    p: "Tell us a little about your organization and what you're looking to improve. We'll use that information to make the conversation more relevant to your workflows, team and operating environment. After submitting your information, you'll be able to select an available time to meet with the ReTax360 team.",
    btn: 'Continue to Available Times',
    note: 'Next, choose an available time that works for you.',
    optional: false,
  },
  'enterprise-contact': ENTERPRISE_CONTACT_COPY,
  sales: ENTERPRISE_CONTACT_COPY,
};

export const isDemoIntent = (value: unknown): value is DemoIntent =>
  typeof value === 'string' && Object.hasOwn(INTENTS, value);
